import Collection_Base from 'collection/base';
import Model_Api_Token from 'model/api_token';

export default Collection_Base.extend({
    model: Model_Api_Token
});